import type {NookDatabase} from '../infrastructure/database/database';

/** Presentation-only retirement. Read original import receipts; never modify retained facts. */
const trialReceipts=['dd8ca8e1-4cc1-5917-85cb-67f977432c6f','63f86f94-e057-5dad-827f-2343e17ee4a8'] as const;
export function isRetiredStudyPath(path:string){return path.split(/[?#]/)[0]==='/study'||path.startsWith('/study/');}
export async function retiredTrialObjects(db:NookDatabase){
 const tasks=new Set<string>(),resources=new Set<string>();
 await db.transaction('r',db.operations,db.revisions,async()=>{
  for(const receipt of await db.operations.bulkGet([...trialReceipts])){
   if(!receipt||receipt.kind!=='study-command')continue;
   const revision=await db.revisions.get('study-plan:'+receipt.resultId+':1');
   if(!revision||!('entityType' in revision)||revision.entityType!=='study-plan'||!('taskIds' in revision.snapshot))continue;
   // Current plan refs may contain user-added objects: only initial imported refs are hidden.
   for(const id of revision.snapshot.taskIds)tasks.add(id);
   for(const id of revision.snapshot.resourceIds)resources.add(id);
  }
 });
 return {tasks,resources};
}
export async function currentTasks(db:NookDatabase){const hidden=await retiredTrialObjects(db);return (await db.tasks.toArray()).filter(t=>!hidden.tasks.has(t.id));}
export async function currentResources(db:NookDatabase){const hidden=await retiredTrialObjects(db);return (await db.resources.toArray()).filter(r=>!hidden.resources.has(r.id));}
export function currentSearchRow(row:{kind:string;id:string;path:string},hidden:Awaited<ReturnType<typeof retiredTrialObjects>>){
 if(row.kind.startsWith('study-')||isRetiredStudyPath(row.path))return false;
 const match=/^\/(tasks|resources)\/([^/?]+)/.exec(row.path);
 return !match||!(match[1]==='tasks'?hidden.tasks:hidden.resources).has(match[2]);
}
